/*
    sidebar component should be a component usable for all main views
*/
import React, {useState} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import Popup from "reactjs-popup";                      // maybe useful component to display additional info
import NewProductButton from './NewProductButton';
import {moment, $} from "../../../../../vendor";
import {ListItem} from "../../tasks/styled_components/list";


const ProductSidebar = (props) => {

    const [statusFilter, setStatusFilter] = useState({
        value: 'all'
    });

    const [globalFilter, setGlobalFilter] = useState({});           // set empty object, there are no filters set by default


    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    const handleChangeTo = value => {

        var globalClone = {};

        // update global filter
        Object.assign(globalClone,globalFilter);        // get current values of global filter (all filter)


        setGlobalFilter(globalClone);
        props.setSelectedFilter(globalClone);           // cloned object must be used because global filter is not yet updated
    };

    const onStatusFilterChange = (val) => {

        setStatusFilter({value: val});                  // set status filter
        var clone = {};
        Object.assign(clone,globalFilter);              // get current filter settings (all filter)
        if (val === 0){
            clone.findForStandard = true;
            delete clone['parent_id'];
        } else if (val !== 'all') {
            // add status filter to global filter
            clone.parent_id = val;
            delete clone['findForStandard'];
        } else {
            // remove status filter from global filter
            delete clone['parent_id'];
            delete clone['findForStandard'];
        }

        setGlobalFilter(clone);
        props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
    };

    return (
        <aside
            id="inb-c-sidebar"
            className="products-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title sticky-top">
                <h1 className="inb-page-title">
                    {t("products",null,"capital")}
                </h1>
            </header>

            <div className="sticky-top-filter">
            <ul id="inb-c-left-bar-flist--product-type"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('product type',null,'capital')}
                </span>
                {['all',0, 153, 154].map(parent_id => (
                    <ListItem
                        className={parent_id === statusFilter.value ? 'active' : ''}
                        key={parent_id}>

                  <span onClick={() => onStatusFilterChange(parent_id)}>
                    {(parent_id===153)?t('contingents',null,'capital'):(parent_id===154)?t('extra options',null,'capital'):(parent_id===0)?t('standard products',null,'capital'):t('all',null,'capital')}
                  </span>

                        {statusFilter.value !== null && statusFilter.value !== 'all' && statusFilter.value === parent_id &&
                        <a
                            href="#"
                            className="unset-filter"
                            onClick={() => onStatusFilterChange('all')}
                            title={t('unselect_filter')}>
                            x
                        </a>
                        }
                    </ListItem>
                ))}
            </ul>
            </div>
            {rbac.hasPermission('write') &&
            <footer
                className="inb-c-left-bar__footer small-only-float-container center-on-content"
                data-inb-action-link="write">
                <a href="#"
                    id="toggle-left-bar"
                    className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"></i>
                        <span className="show-for-sr">t('open_filter_menu')</span>
                </a>
                <NewProductButton
                    onClicked={props.addNewProduct}
                />
            </footer>
            }
        </aside>
    );
};

export default ProductSidebar;